// extracted by mini-css-extract-plugin
module.exports = {"button":"SearchBar_button__2Z4PG","input":"SearchBar_input__1ZzsR"};